import { createFileRoute } from "@tanstack/react-router";
import { PublicLayoutView } from "../views/public/layout/public-layout-view";

export const Route = createFileRoute("/_public")({
  component: PublicLayoutView,
});
